





















import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import { BlocksGettersMixin } from '@/store/modules/blocks/blocks.mixins'
import { getMappingForType } from '@/store/modules/blocks/maps'
import Loader from '@/components/misc/Loader.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import EVMBlockSummary from '@/components/Block/EVMBlockSummary.vue'
import { IEVMBlockParam } from '@/services/evmblocks/evmblocks.service'

@Component({
    components: {
        Loader,
        HTTPError,
        EVMBlockSummary,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class EVMBlockPage extends Mixins(BlocksGettersMixin) {
    @Watch('blockId')
    onblockIdChanged() {
        this.updateBlock()
    }

    @Watch('assetsLoaded')
    onAssetsLoaded() {
        this.updateBlock()
    }

    @Watch('routeLink')
    rerender() {
        this.updateBlock()
    }
    created() {
        this.updateBlock()
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get blockId(): string {
        return this.$route.params.id
    }
    get routeLink() {
        return this.$route.path
    }
    get block() {
        return this.getEVMBlock()
    }

    get loading() {
        return this.isFetching()
    }

    updateBlock() {
        if (this.assetsLoaded) {
            const payload: IEVMBlockParam = {}

            if (this.blockId.startsWith('0x')) payload.hash = this.blockId
            else payload.height = this.blockId

            this.$store.dispatch('Blocks/getEVMBlock', payload)
        }
    }
}
